import { api } from './api'

function report(kind: string, message: string, extra?: Record<string, unknown>) {
  console.error(`[Brief Portal ${kind}]`, message, extra || {})
  void api('/client-logs', { method: 'POST', body: JSON.stringify({ kind, message, extra }) }).catch(() => undefined)
}

export function installBrowserLogger() {
  window.addEventListener('error', event => report('error', event.message, { file: event.filename, line: event.lineno, column: event.colno }))
  window.addEventListener('unhandledrejection', event => report('unhandledrejection', String(event.reason), { reason: String(event.reason) }))
  console.info('[Brief Portal] browser logging enabled')
}
